import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { DESC_ENTITY } from '@constants/desc-entity';
import { enumWeightUnit } from '@data-layer/enums/common';
import { ManagementIsfModel } from '@data-layer/models/management';

import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { IsfHelper } from '@helpers/isf.helper';
import { WEIGHT_UNIT_KG, WEIGHT_UNIT_LB } from '@constants/constants';
import { IsfEstimatedInfoModel, IsfModel } from '@data-layer/models/isf';
import { IsfDetailsValidationService } from '../../services';

@Component({
  selector: 'isf-informal-estimation-details',
  templateUrl: './isf-informal-estimation-details.component.html',
  styleUrls: ['./isf-informal-estimation-details.component.scss'],
})
export class IsfInformalEstimationDetailsComponent implements OnInit, OnChanges {
  @Input() public canEdit = true;
  @Input() public isf: IsfModel | ManagementIsfModel;
  @Output() public entityCodeEdit: EventEmitter<any> = new EventEmitter<any>();

  public info = DESC_ENTITY.IE;
  public estimatedIsfInfo: IsfEstimatedInfoModel;
  public enumWeightUnit: typeof enumWeightUnit = enumWeightUnit;
  public DEFAULT_CURRENCY_CODE: string = DEFAULT_CURRENCY_CODE;
  public WEIGHT_UNIT_KG: string = WEIGHT_UNIT_KG;
  public WEIGHT_UNIT_LB: string = WEIGHT_UNIT_LB;

  constructor(private isfDetailsValidationService: IsfDetailsValidationService) {}

  public ngOnInit(): void {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.isf) {
      this.estimatedIsfInfo = IsfHelper.getEstimatedInformation(this.isf);
    }
  }

  public getValidationText(field: string) {
    const validationMessages = this.estimatedIsfInfo.validationMessages || [];
    const error = validationMessages.find((item) => item.text === field);
    if (!error) {
      return null;
    }
    return `BACK_ERROR.${error.text}`;
  }

  public gotoEdit() {
    this.entityCodeEdit.emit();
  }

  public get haasEstimationValueInvalid(): boolean {
    return this.isfDetailsValidationService.hasInformalEstimationValueInvalid(this.isf);
  }

  public get hasQuantityInvalid(): boolean {
    return this.isfDetailsValidationService.hasInformalQuantityInvalid(this.isf);
  }

  public get hasWeightInvalid(): boolean {
    return this.isfDetailsValidationService.hasInformalWeightInvalid(this.isf);
  }

  public get isInvalid(): boolean {
    return this.isfDetailsValidationService.hasInformalEstimationError(this.isf);
  }
}
